import { MODULE_ICON, EXTRA_ICON } from "./moduleIcons";

/**
 * 通知共用中繼資料(DCK-00 / DCK-07)。
 * 來源模組 → 圖示:鈴鐺下拉與訊息中心共用。
 *
 * Figma DCK-00 註記「其餘相關模組樣式參考,統一跟選單icon一樣」→
 * 這裡的圖示必須與側欄選單(15:848)同一組 boxicons,不可各自為政。
 * 圓底樣式由 <NoticeIcon> 統一負責。
 */
export const SOURCE_META = {
  審核訊息: { icon: EXTRA_ICON.審核訊息 },
  批次匯入: { icon: EXTRA_ICON.批次匯入 },
  營運資訊: { icon: MODULE_ICON.營運資訊 },
  資產管理: { icon: MODULE_ICON.資產管理 },
  監控派工: { icon: MODULE_ICON.監控派工 },
  訊息功能: { icon: MODULE_ICON.訊息功能 },
  決策分析: { icon: MODULE_ICON.決策分析 },
  人員管理: { icon: MODULE_ICON.人員管理 },
};

/** 找不到來源時的預設圖示 */
export const DEFAULT_SOURCE_ICON = MODULE_ICON.訊息功能;

/**
 * 這筆通知目前是否被暫停規則(來源模組 × 型別;ticket 13)靜音。
 * 暫停是規則層級的,不是單筆旗標;同一 pair 若有多筆規則(退回重送),取最新一筆判斷。
 * 只有 active(審核通過後才會是 true)才算真的暫停 —— 送審中的規則還不生效。
 */
export function isNotificationMuted(n, rules = []) {
  const latest = rules
    .filter((r) => r.source === n.source && r.type === n.type)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
  return !!latest?.active;
}

/**
 * 相對時間(Figma 通知樣式參考:「1 小時前」)。
 * 1 小時內 → N 分鐘前;24 小時內 → N 小時前;7 天內 → N 天前;否則日期。
 */
export function formatNotifyTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const diffMs = now - d;
  if (Number.isNaN(diffMs) || diffMs < 0) {
    return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
  }
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "剛剛";
  if (mins < 60) return `${mins} 分鐘前`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} 小時前`;
  const days = Math.floor(hours / 24);
  if (days <= 7) return `${days} 天前`;
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
